// NO EDITAR A MANO
import {ITraduccionMapKeys} from "services-comun/modules/traduccion/map";

import {checkClean} from "../langs";

export interface NoticiasCategoriasRecord extends ITraduccionMapKeys {
    "1"?: string;
    "2"?: string;
    "3"?: string;
    "4"?: string;
    "6"?: string;
}
export type NoticiasCategoriasKeys = keyof NoticiasCategoriasRecord;

export interface NoticiasCategoriasRamRecord extends ITraduccionMapKeys {
    "1"?: string;
    "2"?: string;
    "3"?: string;
    "4"?: string;
    "5"?: string;
    "6"?: string;
    "7"?: string;
    "8"?: string;
    "9"?: string;
    "10"?: string;
}
export type NoticiasCategoriasRamKeys = keyof NoticiasCategoriasRamRecord;

export interface Noticias {
    categorias: (key: NoticiasCategoriasKeys)=>string;
    categorias_ram: (key: NoticiasCategoriasRamKeys)=>string;
}

const MAPPING: Record<string, string> = {
    "de-DE": "de",
    "en-GB": "en",
    "en-US": "en",
    "es-BO": "es",
    "es-CR": "es",
    "es-DO": "es",
    "es-EC": "es",
    "es-ES": "es",
    "es-HN": "es",
    "es-PA": "es",
    "es-PE": "es",
    "es-VE": "es",
    "fr-FR": "en",
    "it-IT": "it",
    "nl-NL": "_",
    "pt-PT": "pt",
    "ru-RU": "_"
};

export default (lang: string, defecto?: string): Promise<Noticias> => import(/* webpackChunkName: "i18n/[request]/noticias" */ `i18n/.src/${checkClean(lang, defecto, MAPPING)}/noticias`).then(module=> module.default);
